/**
 * Oralic “WHAT WE TEST” pattern: horizontal tiny-slider of cards that reveal
 * a background image + bullet list on hover/focus (https://oralic.webflow.io/).
 */
export function initOfferSlider(loco) {
  const section = document.querySelector(".offer-slider");
  const track = section?.querySelector("[data-offer-slider]");
  const prevBtn = section?.querySelector("[data-offer-slider-prev]");
  const nextBtn = section?.querySelector("[data-offer-slider-next]");
  const tnsFactory = window.tns;

  if (!section || !track || !prevBtn || !nextBtn || !tnsFactory) return;

  const slides = [...track.querySelectorAll(".offer-slider__slide")];
  if (!slides.length) return;

  const stageShell = section.querySelector(".offer-slider__stage-shell");

  slides.forEach((slide, index) => {
    slide.dataset.inviewDelay = String(index + 1);
  });

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const touchUi = window.matchMedia("(hover: none)").matches;

  const bumpLoco = () => loco?.bump?.();

  const instance = tnsFactory({
    container: track,
    items: 1,
    gutter: 16,
    controls: true,
    controlsContainer: ".offer-slider__controls",
    prevButton: prevBtn,
    nextButton: nextBtn,
    nav: false,
    mouseDrag: true,
    loop: true,
    speed: reduceMotion ? 0 : 500,
    responsive: {
      576: { items: 1, gutter: 16 },
      768: { items: 2, gutter: 20 },
      1200: { items: 3, gutter: 24 },
    },
  });

  if (!instance) return;

  let activeSlide = null;

  const setActiveSlide = (slide) => {
    if (!touchUi) return;
    if (activeSlide === slide) {
      slide.classList.remove("is-active");
      activeSlide = null;
      return;
    }
    if (activeSlide) activeSlide.classList.remove("is-active");
    slide.classList.add("is-active");
    activeSlide = slide;
  };

  slides.forEach((slide) => {
    slide.addEventListener(
      "click",
      () => {
        if (touchUi) setActiveSlide(slide);
      },
      { passive: true },
    );
  });

  section.addEventListener("pointerdown", (e) => {
    if (!touchUi || !activeSlide) return;
    if (!activeSlide.contains(e.target)) {
      activeSlide.classList.remove("is-active");
      activeSlide = null;
    }
  });

  instance.events.on("transitionEnd", bumpLoco);
  instance.events.on("indexChanged", bumpLoco);

  const refresh = () => {
    if (typeof instance.refresh === "function") instance.refresh();
    bumpLoco();
  };

  window.addEventListener("resize", refresh);
  refresh();

  if (stageShell) loco?.bump?.();
}
